export const T = (lang, lut) => {
    return lut[lang]
  }